"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ixdIconsReact = require("@tencent/ixd-icons-react");
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/* eslint-disable react/no-unknown-property */

/**
 * 移动端的折叠面板组件
 */
var SceneCollapse = function SceneCollapse(_a) {
  var className = _a.className,
    style = _a.style,
    tabs = _a.tabs,
    defaultActiveKey = _a.defaultActiveKey;
  var _b = (0, _react.useState)(function () {
      var _a;
      return defaultActiveKey !== undefined ? defaultActiveKey : (_a = tabs === null || tabs === void 0 ? void 0 : tabs[0]) === null || _a === void 0 ? void 0 : _a.key;
    }),
    activeKey = _b[0],
    setActiveKey = _b[1];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(className, 'comp-scene-collapse'),
    style: style
  }, /*#__PURE__*/_react["default"].createElement("ul", null, tabs.map(function (tab, idx) {
    var _a;
    var active = String(activeKey) === String(tab.key); // 当前是否属于展开态
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: (_a = tab.key) !== null && _a !== void 0 ? _a : idx,
      className: (0, _classnames["default"])({
        active: active
      }),
      "report-event": "click_tab_button",
      "report-ext1": idx,
      "report-ext2": tab.label || '',
      "report-ext3": "mobile",
      onClick: function onClick(e) {
        var _a;
        // 点击超链接，不处理折叠
        if (((_a = e.target) === null || _a === void 0 ? void 0 : _a.nodeName) === 'A') {
          return;
        }
        // 已经展开态，点击就关闭 (最多只有一个处于展开态)
        setActiveKey(active ? '' : tab.key);
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "comp-collapse__header"
    }, /*#__PURE__*/_react["default"].createElement("p", null, tab.label), /*#__PURE__*/_react["default"].createElement(_ixdIconsReact.DownIcon, {
      className: "icon-down"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "comp-collapse__content"
    }, tab.children));
  })));
};
var _default = exports["default"] = SceneCollapse;